import { generateNonce, verifySiwf } from "./actions/index.js";
import { createConfig } from "./config.js";
/**
 * For use on frontends where JWT verification is not necessary.
 */
export function createLightClient(options = {}) {
    const config = createConfig(options);
    return {
        generateNonce: () => generateNonce(config),
        verifySiwf: (options) => verifySiwf(config, options),
    };
}
